import React, { FunctionComponent } from 'react';
import styled from 'styled-components';
import THEME from 'theme';
import { SCREEN } from 'scenes/common/types/screen';

interface SectionProps {
  id: string;
  center?: boolean;
  column?: boolean;
  justify?: boolean;
  selected?: boolean;
  onClick?: () => void;
  tabIndex?: number;
  padding?: string;
  margin?: string;
}

const Container = styled.div<SectionProps>`
  display: flex;
  flex-direction: ${(props) => (props.column ? 'column' : 'row')};
  justify-content: ${(props) => (props.justify ? 'space-between' : 'center')};
  align-items: ${(props) => (props.center ? 'center' : 'flex-start')};
  padding: ${(props) => (props.padding ? props.padding : '1rem')};
  margin: ${(props) => (props.margin ? props.margin : '1rem 0rem')};
  border-radius: 6px;
  border: ${(props) => (props.selected ? '2px' : '1px')} solid
    ${(props) =>
      props.selected ? THEME.FIELD.BORDER.VALID : THEME.FIELD.BORDER.DEFAULT};
  cursor: ${(props) => (props.onClick === undefined ? 'default' : 'pointer')};

  div {
    p {
      margin: 0;
    }
  }

  .i-check-circle {
    color: ${(props) =>
      props.selected
        ? THEME.TICK_ICON.VALID
        : THEME.TICK_ICON.DEFAULT} !important;
  }
  @media (max-width: ${SCREEN.SMALL}px) {
    padding: 1rem;
  }
`;

export const Section: FunctionComponent<SectionProps> = ({
  id,
  children,
  center,
  column,
  justify,
  selected,
  tabIndex = 0,
  padding,
  margin,
}) => (
  <Container
    tabIndex={tabIndex}
    id={id}
    aria-pressed={selected}
    center={center}
    column={column}
    justify={justify}
    selected={selected}
    padding={padding}
    margin={margin}
  >
    {children}
  </Container>
);

export default Section;
